import React, { useContext, useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

import css from "./Today.module.css";
import { UserContext } from "../../Context/UserContext";
import { Head } from "../../Utils/Head";
import { terActs0, terActs1 } from "../../Utils/terActs";
import { updateUserFirebase } from "../../Utils/firebaseUser";

export const Today = () => {
  const { userData, setUserData } = useContext(UserContext);
  const [terActsList, setTerActsList] = useState("");
  const [actsToday, setActsToday] = useState([]);
  const [actDone, setActDone] = useState(false);
  const [actButtonDone, setActButtonDone] = useState(false);
  const [actComment, setActComment] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setTerActsList(terActs0);
    userData &&
      userData.journey &&
      userData.journey.level &&
      userData.journey.level !== 0 &&
      setTerActsList(terActs1);
  }, [userData, terActsList]);

  useEffect(() => {
    userData &&
      userData.diary &&
      userData.diary[dayjs().format("YYMMDD")] &&
      setActsToday([
        ...userData.diary[dayjs().format("YYMMDD")].filter((a) => !a.done),
      ]);
  }, [userData]);

  function handleActDone(a) {
    let updatedList = [...userData.diary[a.date]];

    updatedList.forEach((element) => {
      if (element.id === a.id) {
        element.done = true;
        element.comment = actComment;
      }
    });
    userData.diary[a.date] = [...updatedList];

    a.date === dayjs().format("YYMMDD") &&
      setActsToday(updatedList.filter((a) => !a.done));

    setUserData(userData);
    updateUserFirebase(userData);
  }

  if (userData) {
    return (
      <div className={css.container}>
        <Head title="Today" description={"User - Mairini"} />
        <section className={css.main}>
          <div className={css.sectionDiaryInstructions}>
            <p className={css.link} onClick={() => navigate("/contact")}>
              Agende um atendimento para ter acesso a todos os recursos
            </p>
            {!userData.personalityTraits && (
              <p>
                Faça os questionários para uma avaliação mais personalizada{" "}
              </p>
            )}
            {userData.listValues[0] === 0 && (
              <button
                className="defaultButton"
                onClick={() => navigate("/teract/values-and-trends")}
              >
                Questionário de Valores
              </button>
            )}
            {!userData.personalityTraits && (
              <button
                className="defaultButton"
                onClick={() => navigate("/teract/discovering-your-personality")}
              >
                Questionário de Personalidade
              </button>
            )}
          </div>

          <div className={css.sectionTodayDiary}>
            <h1>Ações de hoje</h1>
            {actsToday[0] &&
              actsToday.map((a, i) => (
                <div className={css.card} key={i}>
                  <h4>{a.act}</h4>
                  <p>Valor: {a.value}</p>
                  <div className={css.cardMood}></div>
                  {a.done ||
                    (dayjs().format("YYMMDD") >= a.date && (
                      <>
                        <div className={css.cardMood}>
                          <p>Realizada?</p>
                          <label className={css.confirmation}>
                            Sim
                            <input
                              type="checkbox"
                              checked={actDone === a.id}
                              onChange={() => {
                                setActDone(a.id);
                              }}
                            />
                            <span className={css.checkmark}></span>
                          </label>
                          <label className={css.confirmation}>
                            Não
                            <input
                              type="checkbox"
                              checked={actDone !== a.id}
                              onChange={() => {
                                setActDone(false);
                              }}
                            />
                            <span className={css.checkmark}></span>
                          </label>
                        </div>

                        <div className={css.comments}>
                          <p>Comentário/Reflexão:</p>
                          <input
                            maxLength="150"
                            placeholder="Escreva aqui"
                            autoComplete="off"
                            required
                            onChange={(e) => {
                              setActComment(e.target.value);
                              setActButtonDone(a.id);
                            }}
                          />
                        </div>
                      </>
                    ))}

                  {actComment && actButtonDone === a.id ? (
                    <button
                      className="greenButton"
                      onClick={() => handleActDone(a)}
                    >
                      Salvar
                    </button>
                  ) : (
                    <button className={css.buttonDisabled}>Salvar</button>
                  )}
                </div>
              ))}
          </div>
        </section>

        {/* {userData.member && (
          <section>
            <h1>Cards</h1>
            {terActsList.map((act, i) =>
              userData.journey && i <= userData.journey.lesson ? (
                <div
                  key={act.slug}
                  className={`${css.cardStart} ${css.cardStartActive}`}
                  onClick={() => navigate(`/teract/${act.slug}`)}
                >
                  <i className={`material-icons`}>{act.icon}</i>
                  <h4>{act.title}</h4>
                </div>
              ) : (
                <div key={act.slug} className={`${css.cardStart}`}>
                  <i className={`material-icons`}>{act.icon}</i>
                  <h4>{act.title}</h4>
                </div>
              )
            )}
          </section>
        )} */}
      </div>
    );
  } else {
    return (
      <div className={css.container}>
        <section>
          <div className={css.schedule}>
            <h2>Agenda {dayjs().format("DD.MM.YY")}</h2>
            <h5>Aqui você visualiza a agenda do seu dia.</h5>
          </div>
        </section>
      </div>
    );
  }
};
